import React, { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { isAdmin, fetchAuthStatus } from "../../utils/authUtils";
import { CircularProgress, Box } from "@mui/material";
import { userInfo } from "../../lib/api_service/userInfo";

export const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  // Query for authentication status
  const {
    data: isAuthenticated = false,
    refetch: refetchAuth,
    isLoading: isLoadingAuth,
  } = useQuery({
    queryKey: ["authStatus"],
    queryFn: fetchAuthStatus,
    retry: false,
    refetchOnWindowFocus: true,
  });

  // Separate query for admin status
  const {
    data: isAdminUser = false,
    refetch: refetchAdmin,
    // isLoading: isLoadingAdmin
  } = useQuery({
    queryKey: ["adminStatus"],
    queryFn: isAdmin,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    enabled: isAuthenticated, // Only run this query if the user is authenticated
  });
  console.log("Auth state", { isAuthenticated, isLoadingAuth });
  // Combine refetch functions
  const refetchAll = () => {
    refetchAuth();
    refetchAdmin();
  };

  const { data: userData } = useQuery({
    queryKey: ["userInfo"],
    queryFn: userInfo,
    retry: false,
    refetchOnWindowFocus: true,
  });

  // Show a white screen while loading
  if (isLoadingAuth) {
    console.log("Still loading auth...");
    return (
      <Box sx={{ display: "flex" }}>
        <CircularProgress />
      </Box>
    );
  }
  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        isAdmin: isAdminUser,
        refetchAuth: refetchAll,
        userInfo: userData,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
